import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './DatePicker.css'
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router,Switch,Route, Redirect} from "react-router-dom";
import Login from './Pages/Auth/Login';
import { ToastContainer } from 'react-toastify';

const isLogin=()=>!!localStorage.getItem('electronicStepsAdmin')
const PublicRoute=({component,...props})=>{
  return <Route {...props} render={(props)=>{
    if(isLogin()){
      return <Redirect to={'/'}/>
    }
    else{
      return React.createElement(component,props)
    }
  }}></Route>
}


const PrivatRoute=({render,...props})=>{
  return <Route {...props} render={(props)=>{
      if(isLogin())
          return render(props);
          
      else{
          return <Redirect to="/login"/>
      }    
  }}/>
}
ReactDOM.render(
  
  <React.StrictMode>
    <Router>
      <Switch>
          <PublicRoute exact path='/login' component={Login}/>
          <PrivatRoute path="/" render={()=><App/>}/>
      </Switch>
    </Router>
    <ToastContainer limit={3}/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
